<template>
	<div class="container">
		<triangle-image
			title="Come spediamo<br>la tua box">
		</triangle-image>

		<div >
			<div class="content">
				<section class="section-how">
					<div class="container-how">
						<h2>Il viaggio climatizzato degli ingredienti</h2>

						<p>Il nostro packaging è essenziale ed è pensato per garantire la freschezza degli alimenti. I prodotti freschi vengono inseriti in un contenitore isotermico che, insieme alle buste ghiaccio, garantisce una temperatura tra 0° e 4°C. Carne, pesce e latticini viaggiano così in tutta sicurezza fino a casa tua!</p>

						<p>Nella parte non refrigerata della nostra scatola troverai invece i prodotti secchi (pasta, riso, pane etc.) e le verdure che non hanno bisogno di mantenersi al fresco (patate, cipolle, aglio, carote etc.)</p>

						<p>Le nostre verdure sono confezionate in sacchetti biodegradabili, suddivise in base alle ricette scelte per semplificare ancor di più la preparazione dei tuoi piatti, mentre i prodotti freschi sono confezionati sottovuoto o ad atmosfera controllata direttamente dai nostri fornitori.</p>

						<br>
					</div>
				</section>

				<div class="img-box"></div>

				<section class="section-how text-left">
					<div class="container-how">
						<p><i class="fas fa-check"></i>&nbsp; Freschezza: l'imballaggio garantisce la temperatura e la conservazione ottimale dei prodotti freschi.</p>
						<p><i class="fas fa-check"></i>&nbsp; Riciclabilità: smaltisci cartone e plastica nei rispettivi cassonetti, il sacchetto isotermico e il gel refrigerante nell'indifferenziata.</p>
						<p><i class="fas fa-check"></i>&nbsp; Affidabilità: è sempre disponibile la consegna espressa gratuita per garantirti il miglior servizio possibile. Su alcuni cap sono disponibili a pagamento le consegne presso i punti di ritiro “Fermopoint“ o su fascia oraria inferiore alle 5 ore.</p>
					</div>
				</section>

				<br>

				<big-usp>
					<template slot="icon"><i class="fa fa-question-circle fa-4x" aria-hidden="true"></i></template>
					<template slot="title">Domande frequenti</template>
					<template slot="message">
						<p>Se hai ancora qualche dubbio, visita la nostra sezione <router-link :to="{name: 'faq'}" class="link-detail" title="Domande frequenti">domande frequenti</router-link><br>oppure scrivici in chat, la trovi qui a destra</p>
					</template>
				</big-usp>

			</div>

			<start-with-us></start-with-us>
		</div>

	</div>
</template>

<script>

import TriangleImage from '../TriangleImage'
import StartWithUs from '../Parts/StartWithUs'
import BigUsp from '../Parts/BigUsp'

export default {
	components: {
		'triangle-image': TriangleImage,
		'start-with-us': StartWithUs,
		'big-usp': BigUsp
	}
}

</script>

<style scoped>
	h2 {
		margin-bottom: 30px;
	}

	section {
		margin: 30px auto;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.section-how .fa {
		color: var(--quomi-primary);
	}

	.container-how {
		max-width: 768px;
		margin: 0 auto;
	}

	.calendar {
		margin: 10px auto;
	}

	.triangle-image {
		background-image: url("../../assets/img/covers/box-hands.jpeg");
		background-position: center 0;
	}

	.img-box {
		width: 90%;
		max-width: 600px;
		height: 300px;
		background: url("../../assets/img/how/box.jpg") top center no-repeat;
		background-size: contain;
		margin: 30px auto 0 auto;
	}

	@media only screen and (max-width: 600px)  {
		.img-box {
			height: 200px;
		}
	}

	.fa-question-circle {
		color: var(--quomi-primary);
	}

</style>
